var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommercialized(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H28C34.6274 0 40 5.37258 40 12V28C40 34.6274 34.6274 40 28 40H12C5.37258 40 0 34.6274 0 28V12Z",
    fill: "url(#paint0_linear_468_12398)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_468_12398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 25.6666L25.6668 19C25.9783 18.6947 26.2263 18.3307 26.3962 17.929C26.5662 17.5273 26.6548 17.0959 26.657 16.6597C26.6592 16.2236 26.5749 15.7913 26.4091 15.3879C26.2432 14.9845 25.9989 14.618 25.6905 14.3096C25.3821 14.0012 25.0156 13.757 24.6122 13.5911C24.2088 13.4252 23.7766 13.3409 23.3404 13.3431C22.9042 13.3453 22.4728 13.434 22.0712 13.6039C21.6695 13.7739 21.3055 14.0218 21.0002 14.3333L14.3335 21C14.022 21.3053 13.7741 21.6693 13.6041 22.071C13.4342 22.4727 13.3455 22.9041 13.3433 23.3402C13.3411 23.7764 13.4254 24.2087 13.5913 24.612C13.7572 25.0154 14.0014 25.3819 14.3098 25.6903C14.6182 25.9988 14.9847 26.243 15.3881 26.4089C15.7915 26.5748 16.2238 26.659 16.6599 26.6568C17.0961 26.6546 17.5275 26.566 17.9292 26.396C18.3309 26.2261 18.6949 25.9782 19.0002 25.6666Z",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6665 17.6667L22.3332 22.3334",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_12398",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDFAF3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_468_12398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommercialized);
export default __webpack_public_path__ + "static/media/commercialized.a24d1b561f92b98da4d8a503247650b3.svg";
export { ForwardRef as ReactComponent };